Previgesst.xhr.abort = function () {};
(function ($) {

    var fid = $('#formation-en-ligne-container').data('id'),
            s = $('#formation-en-ligne-container').data('s');

    $('.button-formation-cookie').click(function (e) {
        e.preventDefault();
        var url = $(this).data('href'),
                c = Cookies.get('previ_liked_formations') || '',
                formations = c.split(',');
        // convert ids to integer
        formations = formations.map((x) => parseInt(x));

        Previgesst.confirm(
                'Pour suivre cette formation, vous devez vous inscrire et faire l’achat de crédits. Souhaitez-vous procéder?',
                'Suivre nos formations',
                function () {
                    $('#generic-confirm-container').modal('hide');

                    if (-1 === formations.indexOf(fid)) {

                        //setCookie
                        formations.push(fid);
                        formations = formations.filter(Boolean);
                        formations = formations.filter((a, b) => formations.indexOf(a) === b);

                        c = formations.join(',');

                        Cookies.set('previ_liked_formations', c, {path: '/', expires: 365});
                    }
                    // send browser to url
                    window.location.href = url;

                    return true;
                }
        );
    });
    $('.button-formation-request-owner').click(function (e) {
        e.preventDefault();

        var cost = $(this).data('cost'),
                txt = '<p>Vous êtes sur le point de vous assigner une formation qui débitera <b>{d} crédits</b> de votre banque, êtes-vous convaincu de vouloir compléter cette action?</p><p class="cyan"><b><span class="icon icon-gem big"></span> {d} crédits</b></p>';

        Previgesst.confirm(
                txt.replaceAll('{d}', cost),
                'Suivre cette formation',
                function () {
                    Previgesst.xhr.abort();
                    Previgesst.xhr = $.post(
                            Previgesst.ajax,
                            {
                                action: 'formation-request',
                                formation: fid,
                                s: s
                            },
                            function (r) {
                                if (r.success) {
                                    for (var key in r.content) {
                                        $(key).html(r.content[key]);
                                    }
                                    Previgesst.confirm(
                                            'Vous avez acquis cette formation, vous pouvez la débuter dès maintenant ou vous pouvez toujours y accéder à partir de l’onglet <b>« Mes Formations »</b>.',
                                            'Lancer cette formation',
                                            function () {
                                                location.href = r.url;
                                            },
                                            'Lancer cette formation',
                                            'Pas maintenant'
                                            );
                                } else {
                                    Previgesst.alert(r.data[0].message, 'Erreur');
                                }
                            }
                    );
                    return true;
                }
        );

    });

    $('.button-formation-request').click(function (e) {
        e.preventDefault();

        Previgesst.xhr.abort();
        Previgesst.xhr = $.post(
                Previgesst.ajax,
                {
                    action: 'formation-request',
                    formation: fid,
                    s: s
                },
                function (r) {
                    if (r.success) {
                        for (var key in r.content) {
                            $(key).html(r.content[key]);
                        }
                        Previgesst.alert(r.message, 'Succès');
                    } else {
                        Previgesst.alert(r.data[0].message, 'Erreur');
                    }
                }
        );
    });


    $('#assign-formation-to-users').submit(function (e) {
        e.preventDefault;
        var members = [];
        $.each($("input[name='user_ids']:checked:not(:disabled)"), function () {
            members.push($(this).val());
        });
        Previgesst.xhr.abort();
        Previgesst.xhr = $.post(
                Previgesst.ajax,
                {
                    action: 'formation-assign-members',
                    formation: fid,
                    members: members,
                    s: s
                },
                function (r) {
                    $('#assign-formation-to-users-container').modal('hide');
                    if (r.success) {
                        Previgesst.alert(r.message, 'Succès');
                        for (var key in r.content) {
                            $(key).html(r.content[key]);
                        }

                    } else {
                        Previgesst.alert(r.data[0].message, 'Erreur');
                    }
                }
        );
        return false;
    });
}
)(jQuery);